import React from 'react';
import clsx from 'clsx';
import { ChevronDown as ChevronDownIcon } from 'react-feather';
import { CountryCode } from 'api/types/store';
import { Select, TextField } from 'ui-kit';
import { FormControlProps } from 'ui-kit/FormControl/FormControl';
import { InputProps } from 'ui-kit/Input/InputNew';
import { countryCodes, getCountryByCode } from 'utils/geo';

import './ZipCodeInput.scss';

const BASE_CLASS = 'ZipCodeInput';

const countryOptions = countryCodes
  .map((code) => ({ label: getCountryByCode(code).name, value: code }))
  .sort((a, b) => a.label.localeCompare(b.label));

interface Props extends Omit<FormControlProps, 'children'> {
  country: CountryCode;
  onCountryChange: (country: CountryCode) => void;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  name?: string;
  placeholder?: string;
  inputRef?: InputProps['inputRef'];
}

export default function ZipCodeInput({
  country,
  onCountryChange,
  placeholder = '12345',
  disabled = false,
  className,
  ...rest
}: Props) {
  return (
    <TextField
      className={clsx(BASE_CLASS, className)}
      placeholder={placeholder}
      disabled={disabled}
      inputProps={{ autoComplete: 'postal-code' }}
      InputProps={{
        startAdornment: (
          <Select
            showSearch
            bordered={false}
            aria-label="Country"
            value={country}
            onChange={(value) => onCountryChange(value as CountryCode)}
            options={countryOptions}
            optionLabelProp="value"
            filterOption={(input, option) => {
              const query = input.toLowerCase();
              return (
                String(option.value).toLowerCase() === query ||
                String(option.children).toLowerCase().includes(query)
              );
            }}
            disabled={disabled}
            suffixIcon={<ChevronDownIcon size={16} />}
            listHeight={240}
            dropdownClassName={`${BASE_CLASS}-dropdown`}
            dropdownMatchSelectWidth={false}
            dropdownStyle={{ width: '100%' }}
            dropdownAlign={{ offset: [0, 8] }}
            getPopupContainer={(trigger) => trigger.closest(`.${BASE_CLASS}`)}
          />
        ),
      }}
      {...rest}
    />
  );
}
